import { render } from "./BatchClassSubView.vue?vue&type=template&id=b69829b0&ts=true"
import script from "./BatchClassSubView.vue?vue&type=script&lang=ts"
export * from "./BatchClassSubView.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__